import { createFileRoute } from "@tanstack/react-router";
import { ChartView } from "@/views";

type ChartsSearch = {
  code?: string;
};

export const Route = createFileRoute("/_dashboard/charts")({
  component: ChartsPage,
  validateSearch: (search: Record<string, unknown>): ChartsSearch => {
    return {
      code: typeof search.code === "string" ? search.code : undefined,
    };
  },
});

function ChartsPage() {
  const { code } = Route.useSearch();
  return <ChartView initialCode={code} />;
}
